/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  PatchedProCertificationPartialUpdateRequest,
  ProCertificationCreate,
  ProCertificationCreateRequest,
  ProCertificationPartialUpdate
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getProCertificationsCreateUrl = () => {




  return `/api/pro-certifications/`
}

/**
 * A view that Admins use to create and update ProCertifications.
 */
export const proCertificationsCreate = async (proCertificationCreateRequest: ProCertificationCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<ProCertificationCreate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ProCertificationCreate>(getProCertificationsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(proCertificationCreateRequest)
  }
);}





export const getProCertificationsCreateMutationKey = () => ['proCertificationsCreate'] as const;

export const getProCertificationsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proCertificationsCreate>>, TError,ProCertificationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof proCertificationsCreate>>, TError,ProCertificationsCreateMutationVariables, TContext> => {

const mutationKey = getProCertificationsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proCertificationsCreate>>, ProCertificationsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  proCertificationsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProCertificationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof proCertificationsCreate>>>
    export type ProCertificationsCreateMutationBody = ProCertificationCreateRequest
    export type ProCertificationsCreateMutationError = void
    export type ProCertificationsCreateMutationVariables = {data: ProCertificationCreateRequest}

    export const useProCertificationsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proCertificationsCreate>>, TError,ProCertificationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proCertificationsCreate>>,
        TError,
        ProCertificationsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getProCertificationsCreateMutationOptions(options), queryClient);
    }
    export const getProCertificationsPartialUpdateUrl = (id: string,) => {




  return `/api/pro-certifications/${id}/`
}

/**
 * A view that Admins use to create and update ProCertifications.
 */
export const proCertificationsPartialUpdate = async (id: string,
    patchedProCertificationPartialUpdateRequest?: PatchedProCertificationPartialUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<ProCertificationPartialUpdate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ProCertificationPartialUpdate>(getProCertificationsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedProCertificationPartialUpdateRequest)
  }
);}





export const getProCertificationsPartialUpdateMutationKey = () => ['proCertificationsPartialUpdate'] as const;

export const getProCertificationsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proCertificationsPartialUpdate>>, TError,ProCertificationsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof proCertificationsPartialUpdate>>, TError,ProCertificationsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getProCertificationsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proCertificationsPartialUpdate>>, ProCertificationsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  proCertificationsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProCertificationsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof proCertificationsPartialUpdate>>>
    export type ProCertificationsPartialUpdateMutationBody = PatchedProCertificationPartialUpdateRequest | undefined
    export type ProCertificationsPartialUpdateMutationError = void
    export type ProCertificationsPartialUpdateMutationVariables = {id: string;data?: PatchedProCertificationPartialUpdateRequest}

    export const useProCertificationsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proCertificationsPartialUpdate>>, TError,ProCertificationsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proCertificationsPartialUpdate>>,
        TError,
        ProCertificationsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getProCertificationsPartialUpdateMutationOptions(options), queryClient);
    }
